import React from 'react'
import PropTypes from 'prop-types'
import Slide from "./Slide/index"


class Slider extends React.Component {


    static Slide = Slide


    componentDidMount() {
        const {id} = this.props

        const slider = new window.MasterSlider()

        slider.control('arrows');
        slider.control('timebar', {insertTo: '#masterslider'});
        slider.control('bullets');

        slider.setup(
            id,
            {
                width: 1400,    // slider standard width
                height: 580,   // slider standard height
                space: 0,
                layout: 'autofill',
                loop: true,
                preload: 3,
                autoplay: true,
                view:'mask',
                speed:14,


            })

        slider.control('bullets')


    }


    render() {

        const {id} = this.props

        if (this.props.children.length === 0)
            return null


        return (
            <div className="master-slider ms-skin-default" id={id}>

                {React.Children.map(this.props.children, child => 
                    React.cloneElement(child, {theme: this.props.theme}))}
            </div>

        )
    }
}


Slider.propTypes = {
    id: PropTypes.string.isRequired,
    layout: PropTypes.string,
    view: PropTypes.string,
    speed: PropTypes.number,
    layersMode: PropTypes.string,
    loop: PropTypes.bool,
}

Slider.defaultProps = {
    layout: 'fullwidth',
    view: 'basic',
    speed: 30,
    layersMode: 'autofill',
    loop: true,

}


export default Slider




// WEBPACK FOOTER //
// ./src/components/_home/Slider/index.js